import styles from "./UpcomingInvoices.module.css";
import ResultAndCount from "../../components/ResultAndCount/ResultAndCount";
import SearchBar from "../../components/SearchBar/SearchBar";
import Dropdown from "../../components/Dropdown/Dropdown";
import { IoMdTrash } from "react-icons/io";
import DynamicTable from "../../components/DynamicTable/DynamicTable";
import { useDispatch } from "react-redux";
import { openModal } from "../../redux/slices/modalSlice";
import { useState } from "react";
import PaginationTable from "../../components/PaginationTable/PaginationTable";
import LogoWithName from "../../components/LogoWithName/LogoWithName";
import Action from "../../components/Action/Action";
import CalendarInput from "../../components/CalendarInput/CalendarInput";
import CopyRight from "../../components/CopyRight/CopyRight";

const taskData = [
  {
    _id: "p1",
    studentName: "John Jacob",
    feePlanName: "Fee Plan 1",
    upcomingDate: "2025-04-25",
    dueDate: "2025-04-30",
    amount: 2400,
  },
  {
    _id: "p2",
    studentName: "Jane Smith",
    feePlanName: "Fee Plan 2",
    upcomingDate: "2025-04-26",
    dueDate: "2025-04-30",
    amount: 3600,
  },
  {
    _id: "p3",
    studentName: "Alex Roy",
    feePlanName: "Fee Plan 1",
    upcomingDate: "2025-04-27",
    dueDate: "2025-04-30",
    amount: 1800,
  },
];

function UpcomingInvoices() {
  const dispatch = useDispatch();
  const [selectedDate, setSelectedDate] = useState("");
  const [currentPage, setCurrentPage] = useState(1);
  const [itemsPerPage, setItemsPerPage] = useState(5);
  const [selectedIds, setSelectedIds] = useState([]);
  const [filterDate, setFilterDate] = useState("");
  const totalAmount = taskData.reduce(
    (sum, item) => sum + (item.amount || 0),
    0
  );

  const getColumnData = (data) => {
    return data.map((item) => ({
      studentName: <LogoWithName name={item.studentName || "-"} />,
      feePlanName: item.feePlanName || "Fee Plan 1",
      upcomingDate: item.upcomingDate
        ? new Date(item.upcomingDate).toLocaleDateString("en-GB")
        : "-",
      amount: `INR ${item.amount || 0}`,
      dueDate: item.dueDate
        ? new Date(item.dueDate).toLocaleDateString("en-GB")
        : "-",
    }));
  };

  const displayData = getColumnData(taskData);
  const headingsData = [
    { title: "Student Name", accessor: "studentName" },
    { title: "Fee Plan Name", accessor: "feePlanName" },
    { title: "Upcoming Date", accessor: "upcomingDate" },
    { title: "Amount", accessor: "amount" },
    { title: "Due Date", accessor: "dueDate" },
  ];

  return (
    <div className={styles.main}>
      <div className={styles.background}>
        <div className={styles.headerContainer}>
          {/* Top Status Boxes */}
          <div className={styles.totalDisplay}>
            Total :{" "}
            <span className={styles.totalAmount}>INR {totalAmount}</span>
          </div>

          {/* Filters & Search */}
          <div className={styles.totalstudentcard}>
            <div className={styles.studentsection}>
              <div className={styles.search}>
                <SearchBar
                  placeholder="Search by Name"
                  onChange={(e) => console.log(e.target.value)}
                />
              </div>
              <div className={styles.filters}>
                <Dropdown
                  label="Fee Plan"
                  options={["Annual Day", "Freshers"]}
                  bgColor="rgba(from var(--Utility_Color1) r g b / 1)"
                />
                <CalendarInput
                  label="Date"
                  value={selectedDate}
                  onChange={setSelectedDate}
                  background="var(--Utility_Color1)"
                  textColor="gray"
                  iconColor="gray"
                  placeholderColor="gray"
                  borderRadius="25px"
                  shadow={false}
                />
              </div>
            </div>

            {/* Dynamic Table */}
            <div className={styles.dynamicdata}>
              <DynamicTable
                headings={headingsData}
                columnData={displayData.slice(
                  (currentPage - 1) * itemsPerPage,
                  currentPage * itemsPerPage
                )}
              />
            </div>

            {/* Pagination */}
            <div className={styles.paginationTable}>
              <PaginationTable
                data={displayData}
                currentPage={currentPage}
                itemsPerPage={itemsPerPage}
                setCurrentPage={setCurrentPage}
                setItemsPerPage={setItemsPerPage}
              />
            </div>
          </div>
        </div>
      </div>
      <CopyRight />
    </div>
  );
}

export default UpcomingInvoices;
